import moment from 'moment-timezone'

import { CRUD, CrudModel } from '../../classes'
import { AuthorizationModel } from '../authorization'
import { PatientInsurance } from '../patient-insurance'
import { PatientAccountClearanceData } from './patient-account-clearance.data'
import { PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS } from './patient-account-status'

@CRUD({
  base: '/crud/patient-account-clearance',
})
export class PatientAccountClearanceModel extends CrudModel {
  patientId: string
  accountId: string
  insuranceId: string
  patientInsurance: PatientInsurance
  authorizationId?: string
  authorization?: AuthorizationModel
  code: string
  appointmentId: string
  appointmentStartAt?: moment.Moment
  appointmentTimezone?: string
  appointmentIsOrder?: boolean
  orderingProviderId: string
  referringProviderId: string
  servicingFacilityId: string
  productId: string
  isAuthRequired: boolean
  status: PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS

  constructor(data: PatientAccountClearanceData) {
    super(data, true)

    if (data.patientInsurance) {
      this.patientInsurance = new PatientInsurance(data.patientInsurance)
    }

    if (data.authorization) {
      this.authorization = new AuthorizationModel(data.authorization)
    }

    this.appointmentStartAt = data.appointmentStartAt
      ? this.transformDate(data.appointmentStartAt)
      : undefined
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      patientId: this.patientId,
      accountId: this.accountId,
      insuranceId: this.insuranceId,
      patientInsurance: this.patientInsurance?.toJSON(),
      code: this.code,
      appointmentId: this.appointmentId,
      orderingProviderId: this.orderingProviderId,
      referringProviderId: this.referringProviderId,
      servicingFacilityId: this.servicingFacilityId,
      productId: this.productId,
      isAuthRequired: this.isAuthRequired,
      status: this.status,
    }
  }
}
